// extracted by mini-css-extract-plugin
module.exports = {"root":"TranslateDialog_root__3q6Va","content":"TranslateDialog_content__1z8YN","buttons":"TranslateDialog_buttons__3PuR6"};